/**
 *
 * @module identityToken
 *
 */

/**
 *
 * @class IdentityToken
 *
 */
export default class IdentityToken {

    /**
     *
     * @param {String} token
     * @param {Number} expiration
     *
     */
    constructor(token, expiration) {

        /**
         *
         * @access private
         * @param {String} token
         *
         */
        this.token = token;

        /**
         *
         * @access private
         * @param {Number} expiration
         *
         */
        this.expiration = expiration;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/identityToken.js